module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/cierant-swiper/cierant-swiper.component.scss
// module id = ./src/app/shared/components/cierant-swiper/cierant-swiper.component.scss
// module chunks = main